export const aOrAn = (noun: string) => ("aeiou".includes(noun[0]) ? "an" : "a")
